import React, { useRef, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import emailjs from "@emailjs/browser";
import styles from "./Contact.module.css";
import { EMAILJS_CONFIG } from "../Constants/emailjs.constants";

const mapAddress =
  "No: F71, Plot No: 273, 2nd Main Rd, Block F, Annanagar East, Chennai, Tamil Nadu 600102, India";

export default function Contact() {
  const formRef = useRef(null);
  const location = useLocation();

  const [purpose, setPurpose] = useState("Meeting");
  const [loading, setLoading] = useState(false);
  const [showToast, setShowToast] = useState(false);

  /* ✅ AUTO SELECT + AUTO SCROLL */
  useEffect(() => {
    // Auto-select purpose from Events page
    if (location.state?.enquiry) {
      window.scrollTo({ top: 0, behavior: "smooth" });
      setPurpose(location.state.enquiry);
    }
  }, [location.state]);

  const sendEmail = (e) => {
    e.preventDefault();
    if (loading) return;

    setLoading(true);

    emailjs
      .sendForm(
        EMAILJS_CONFIG.SERVICE_ID,
        EMAILJS_CONFIG.TEMPLATE_ID,
        formRef.current,
        EMAILJS_CONFIG.PUBLIC_KEY
      )
      .then(() => {
        setShowToast(true);
        formRef.current.reset();
        setPurpose("Meeting");
        setTimeout(() => setShowToast(false), 3000);
      })
      .catch(() => {
        alert("Failed to send enquiry. Please try again.");
      })
      .finally(() => setLoading(false));
  };

  return (
    <section className={styles.wrapper}>
      {showToast && (
        <div className={styles.toast}>
          Enquiry sent successfully
        </div>
      )}

      <div className={styles.container}>
        {/* LEFT */}
        <div className={styles.left}>
          <span className={styles.eyebrow}>CONTACT</span>

          <h1 className={styles.title}>
            Get in touch <br /> with us
          </h1>

          <p className={styles.subtitle}>
            Please select the purpose and share your contact details.
          </p>

          {/* PURPOSE SWITCH */}
          <div className={styles.switch}>
            {["Meeting", "Birthday Event"].map((item) => (
              <button
                key={item}
                type="button"
                className={
                  purpose === item
                    ? `${styles.switchBtn} ${styles.active}`
                    : styles.switchBtn
                }
                onClick={() => setPurpose(item)}
                disabled={loading}
              >
                {item}
              </button>
            ))}
          </div>

          {/* FORM */}
          <form
            ref={formRef}
            onSubmit={sendEmail}
            className={styles.form}
          >
            <input
              name="name"
              placeholder="Your Name"
              required
              disabled={loading}
            />

            <input
              name="email"
              type="email"
              placeholder="Email Address"
              required
              disabled={loading}
            />

            <input
              name="phone"
              placeholder="Phone Number"
              required
              disabled={loading}
            />

            <textarea
              name="comments"
              placeholder="Additional comments (optional)"
              rows={4}
              disabled={loading}
            />

            {/* Purpose sent to EmailJS */}
            <input type="hidden" name="purpose" value={purpose} />

            <button
              type="submit"
              className={styles.submit}
              disabled={loading}
            >
              {loading ? (
                <span className={styles.spinner} />
              ) : (
                "Send Enquiry"
              )}
            </button>
          </form>
        </div>

        {/* MAP */}
        <div className={styles.map}>
          <iframe
            title="Location"
            src={`https://www.google.com/maps?q=${encodeURIComponent(
              mapAddress
            )}&output=embed`}
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
}
